import React, {useContext, useEffect, useState} from "react";
import {Col, Container, Row, ListGroup} from "react-bootstrap";
import {
    WEB_ANNOUNCEMENTS_LISTS_URL,
    WEB_ANNOUNCEMENTS_UPDATES_URL
} from "../../../service/UrlConstant";
import {SecurityContext} from "../../../context/security";
import {WebAnnouncementsContext} from "./context";
import CreateButton from "../../../components/AgGridToolbar/ToolBarButtons/CreateButton";
import AnnouncementModal from "../../../components/AgGridToolbar/AnnouncementModal";
import 'bootstrap-icons/font/bootstrap-icons.css';


export default function WebAnnouncements(){
    const {makeGetRequestNoParams, makePutRequest} = useContext(SecurityContext);
    const {announcements, setAnnouncements, show, setShow, showDelete, setShowDelete,
        showCreate, setShowCreate, showEdit, setShowEdit, selectedAnnouncement, setSelectedAnnouncement,
        announcementToBeDeleted, setAnnouncementToBeDeleted,} = useContext(WebAnnouncementsContext);
    const [draggedItemIndex, setDraggedItemIndex] = useState(null);
    const [errorMessage, setErrorMessage] = useState("No Web Announcements available");


    const loadWebAnnouncementsLists = () => {
        const onSuccess = (response) => {
            if(response.data) {
                const sortedAnnouncementsByrowNum = response.data.sort((a, b)=> a.position - b.position);
                setAnnouncements([...sortedAnnouncementsByrowNum]);
            }

        }
        const onError = (err) => {
            console.error(err);
            setErrorMessage(err.response.data)
        }

        makeGetRequestNoParams(WEB_ANNOUNCEMENTS_LISTS_URL, onSuccess, onError);
    };


    const handlePositionsUpdate = (announcements)=>{

        const updatedTedAnnouncements = [...announcements];
        const onSuccess = (response) => {
            setAnnouncements([...response.data]);
        }
        const onError = (err) => {
            console.error(err);
        }

        makePutRequest(updatedTedAnnouncements, WEB_ANNOUNCEMENTS_UPDATES_URL, onSuccess, onError)
    }

    const handleAnnouncementCreate = ()=>{
        setShow(true);
        setShowCreate(true);
    }

    const handleAnnouncementEdit = (announcement)=>{
        setSelectedAnnouncement(announcement)
        setShow(true);
        setShowEdit(true);
    }

    const handleAnnouncementDelete = (announcement)=>{
        setAnnouncementToBeDeleted(announcement)
        setShow(true);
        setShowDelete(true);
    }

    useEffect(()=>{
        loadWebAnnouncementsLists();
    },[])

   const iconStyle = {cursor:'pointer', fontSize: '25px'}

    const handleDragStart = (index)=>{
        setDraggedItemIndex(index);
    }

    const handleDragOver = (e)=>{
        e.preventDefault();
    }

    const handleDrop = (index)=>{
        const draggedItem = announcements[draggedItemIndex];

        const updatedAnnouncements = [...announcements];

        updatedAnnouncements.splice(draggedItemIndex, 1);

        updatedAnnouncements.splice(index, 0, draggedItem);

        const updatedDraggedAnnouncements = updatedAnnouncements.map((announcement, index)=>{
            return {...announcement, position: index + 1}
        })

        setAnnouncements(updatedDraggedAnnouncements);

        setDraggedItemIndex(null);
    }

    const handleRefresh = ()=>{
        window.location.reload();
    }

    return <Container fluid className="d-flex flex-column justify-content-center align-items-center">
        <Row className="w-100">
            <Col>
                <h1 className="pt-3 pb-2 pt-md-4 pb-md-3">Web Announcements</h1>
            </Col>
        </Row >
        <Row className='w-100 bg-light mb-0 p-2 align-items-center border-top border-bottom-none'>
            <Col className="d-flex justify-content-start">
                <h3>Notification</h3>
            </Col>
            <Col className="d-flex justify-content-end">
                {errorMessage !== "No permission to view WebAnnouncements." &&
                <CreateButton
                    showCreate={showCreate}
                    setShowCreate={setShowCreate}
                    handleAnnouncementCreate={handleAnnouncementCreate}/>}
            </Col>
        </Row>
        {announcements && announcements.length === 0 && <h3 className='pt-4'>{errorMessage}</h3>}
        {announcements &&
            <Row className="w-100">
                <Col className="p-0">
                    <ListGroup className='lg:overflow-y-scroll'>
                        {announcements.map((announcement, index)=>
                            <ListGroup.Item
                                key={announcement.id || index}
                                className={`d-flex pt-5 pb-5 pl-4 border-right-0 border-left-0 
                                justify-contents-between align-items-start draggable-item`}
                                draggable
                                onDragStart={()=>handleDragStart(index)}
                                onDragOver={handleDragOver}
                                onDrop={()=>handleDrop(index)}>
                                <span
                                    className='td-icon td-icon-edit2 mr-lg-3 mt-1'
                                    style={iconStyle}
                                    onClick={()=>handleAnnouncementEdit(announcement)}
                                ></span>
                                <span
                                    className='td-icon td-icon-delete mr-lg-5 mt-1'
                                    style={iconStyle}
                                    onClick={()=>handleAnnouncementDelete(announcement)}
                                ></span>
                                <div className='w-100'>
                                    <div className='d-flex'>
                                        <h3 className="mb-4 pt-1 d-flex">
                                            {announcement.header}
                                        </h3>
                                        {announcement.header.startsWith('ALERT') &&
                                            <scan
                                                style={iconStyle}
                                                className='bi bi-bell ml-lg-3'
                                            ></scan>}
                                    </div>

                                    <p>{announcement.content}</p>
                                </div>
                                <span className='td-icon td-icon-hamburger mt-1 mr-2' style={iconStyle}></span>
                            </ListGroup.Item>)}
                    </ListGroup>
                </Col>
            </Row>}
        {errorMessage !== "No permission to view WebAnnouncements." &&
            <Row className="w-100 d-flex justify-content-end align-items-center">
                <Col xs={6} sm={6} md={2} className="pt-2"
                >
                    <button className="btn btn-block td-btn-secondary-clear"
                            onClick={()=>handleRefresh()}
                    >
                        Refresh
                    </button>
                </Col>
                <Col xs={6} sm={6} md={2} className="pt-2">
                    <button className="btn btn-block td-btn-primary-light my-3"
                            id='update'
                            onClick={()=>handlePositionsUpdate(announcements)}
                    >
                        Update
                    </button>
                </Col>
            </Row>
        }
        {show &&
        <AnnouncementModal
            show={show}
            setShow={setShow}
            showCreate={showCreate}
            setShowCreate={setShowCreate}
            showEdit={showEdit}
            setShowEdit={setShowEdit}
            showDelete={showDelete}
            setShowDelete={setShowDelete}
            announcements={announcements}
            setAnnouncements={setAnnouncements}
            selectedAnnouncement={selectedAnnouncement}
            announcementToBeDeleted={announcementToBeDeleted}
            loadWebAnnouncementsLists={loadWebAnnouncementsLists}
        />
    }
    </Container>
}